import { render, staticRenderFns } from "./GroupAnPosts.vue?vue&type=template&id=0bfeea14&scoped=true"
import script from "./GroupAnPosts.vue?vue&type=script&lang=js"
export * from "./GroupAnPosts.vue?vue&type=script&lang=js"
import style0 from "./GroupAnPosts.vue?vue&type=style&index=0&id=0bfeea14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfeea14",
  null
  
)

export default component.exports